import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, parseSelectOptions } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const VMSecureStateMappingForm = forwardRef(function VMSecureStateMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { cloudAccountId, cloudAccountName } = props.record;
      return [{id: cloudAccountId, name: cloudAccountName }]
    }
    return [];
  });

    useEffect(() => {
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
        promise.then((response) => {
          const { projects } = response;
          setProjects(projects);
        }).catch((err)=>{
          message.error('Problem fetching projects')
        });
        
        return cancel;
    }, [props.loginConfigId, props.toolName]);
  
    const getExtraFieldsData = useCallback((config) => {
      const { cloudAccountId } = config;
      return {
        cloudAccountId,
        cloudAccountName: projects.find(project => project.id === cloudAccountId)?.name
      };
    }, [projects])
  
    const extraFields = useMemo(() => ([{
        name: 'cloudAccountId',
        colSpan: 12,
        type: FieldTypes.SELECT,
        label: 'Cloud Account Name',
        options: parseSelectOptions(projects),
        required: true,
        props: {
          autoFocus: true
        }
      }
    ]), [projects]);

    return (
        <GenericMappingForm
          ref={ref}
          {...props}
          projects={projects}
          getExtraFieldsData={getExtraFieldsData}
          extraFields={extraFields}
        />
      )
})

export default VMSecureStateMappingForm;